// Auto-generated actions registry file - do not edit manually
// Language: javascript

const actionsRegistry = {
  actionUpdate: "mrn:meesho:supply_admin:action/update",
  actionDelete: "mrn:meesho:supply_admin:action/delete",
  actionRead: "mrn:meesho:supply_admin:action/read",
  actionCreate: "mrn:meesho:supply_admin:action/create",
  actionDownload: "mrn:meesho:supply_admin:action/download"
};

module.exports = { actionsRegistry };
